/**
 * ErrorInlineMessage — D-UI-ERROR-01.
 *
 * Bubble staff con borde danger + danger-soft bg. NUNCA toast NI modal.
 * Botón "Reintentar" inline tap target ≥44.
 */
import { Icon } from './icons'
interface Props {
  message: string
  onRetry: () => void
}

export function ErrorInlineMessage({ message, onRetry }: Props) {
  return (
    <div className="bubble-row">
      <div
        role="alert"
        aria-live="assertive"
        className="inline-flex items-center gap-3"
        style={{
          maxWidth: '80%',
          padding: '12px 16px',
          borderRadius: 'var(--radius-l)',
          borderBottomLeftRadius: 6,
          background: 'var(--color-danger-soft)',
          border: '1px solid var(--color-danger)',
          color: 'var(--color-text)',
        }}
      >
        <Icon.Alert width={18} height={18} aria-hidden="true" style={{ color: 'var(--color-danger)', flexShrink: 0 }} />
        <span className="text-[14px] flex-1">{message}</span>
        <button
          type="button"
          onClick={onRetry}
          className="text-[13px] font-medium whitespace-nowrap"
          style={{
            minHeight: 44,
            minWidth: 44,
            padding: '8px 14px',
            borderRadius: 999,
            border: '1px solid var(--color-danger)',
            background: 'var(--color-surface)',
            color: 'var(--color-danger)',
            cursor: 'pointer',
          }}
        >
          Reintentar
        </button>
      </div>
    </div>
  )
}
